import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Alert, CircularProgress, Paper } from '@mui/material';
import { sendEmail } from '../services/emailService';

const EmailTest: React.FC = () => {
  const [subject, setSubject] = useState('Test Email AWS SES');
  const [body, setBody] = useState('Ceci est un email de test envoyé depuis AWS SES');
  const [toEmail, setToEmail] = useState(import.meta.env.VITE_AWS_SES_TO_EMAIL || '');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSendEmail = async () => {
    setLoading(true);
    setSuccess(false);
    setError(null);

    try {
      const emails = toEmail.split(',').map(email => email.trim());
      const response = await sendEmail(subject, body, emails);
      console.log('Email envoyé avec succès:', response);
      setSuccess(true);
    } catch (err: any) {
      console.error('Erreur lors de l\'envoi de l\'email:', err);
      setError(err.message || 'Une erreur est survenue lors de l\'envoi de l\'email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Typography variant="h5" gutterBottom>
        Test du Service Email AWS SES
      </Typography>

      <Box sx={{ mt: 3 }}>
        <TextField
          fullWidth
          label="Destinataire(s)"
          value={toEmail}
          onChange={(e) => setToEmail(e.target.value)}
          margin="normal"
          helperText="Séparez plusieurs emails par des virgules"
        />

        <TextField
          fullWidth
          label="Sujet"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
        />

        <TextField
          fullWidth
          label="Message"
          value={body}
          onChange={(e) => setBody(e.target.value)}
          margin="normal"
          multiline
          rows={4}
        />

        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSendEmail}
            disabled={loading || !subject || !body || !toEmail}
            fullWidth
          >
            {loading ? <CircularProgress size={24} /> : 'Envoyer l\'email de test'}
          </Button>
        </Box>

        {success && (
          <Alert severity="success" sx={{ mt: 2 }}>
            Email envoyé avec succès ! Vérifiez votre boîte de réception.
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            Erreur: {error}
          </Alert>
        )}

        <Box sx={{ mt: 3, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Configuration actuelle:</strong><br />
            Région: {import.meta.env.VITE_AWS_REGION}<br />
            From: {import.meta.env.VITE_AWS_SES_FROM_EMAIL}<br />
            Reply-To: {import.meta.env.VITE_AWS_SES_REPLY_TO_EMAIL}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default EmailTest;
